import createStore from "./createStore";
export default createStore(require.context("./modules", false, /\.js$/));
